import StudentList from '../components/StudentList';

export default function StepSelectStudents({
  loading,
  students,
  selectedStudents,
  onChange,
}) {
  return (
    <div>
      <h4>Select Student(s)</h4>
      <StudentList
        loading={loading}
        students={students}
        selectedStudents={selectedStudents}
        onChange={onChange}
      />
    </div>
  );
}
